module.exports = __webpack_public_path__ + "img/1.80e4bdf2.png";